// Estilos del Pricer Datec — namespaced para no chocar con la app.

export function PricerDatecStyles() {
  return (
    <style>{`
      .pd-root * { box-sizing: border-box; }
      .pd-mono { font-family: "IBM Plex Mono", ui-monospace, SFMono-Regular, Menlo, Consolas, monospace; font-variant-numeric: tabular-nums; }
      .pd-serif { font-family: "Inter", system-ui, -apple-system, "Segoe UI", sans-serif; letter-spacing: -0.02em; }
      .pd-root input, .pd-root select { font-family: inherit; font-size: 13px; }
      /* En oscuro, los controles del navegador (el calendario de la fecha, la flecha del select) también. */
      .dark .pd-root input, .dark .pd-root select, .dark .pd-root textarea { color-scheme: dark; }
      .pd-root input:focus, .pd-root select:focus { outline: 2px solid hsl(var(--primary)); outline-offset: -1px; border-color: hsl(var(--primary)) !important; }
      .pd-root input[type=number]::-webkit-inner-spin-button,
      .pd-root input[type=number]::-webkit-outer-spin-button { -webkit-appearance: none; margin: 0; }
      .pd-root input[type=number] { -moz-appearance: textfield; }
      .pd-field-input {
        width: 100%; padding: 8px 12px; border: 1px solid hsl(var(--border));
        background: hsl(var(--card)); border-radius: 6px; transition: all 0.15s;
        color: hsl(var(--foreground));
      }
      .pd-field-input:hover:not(:disabled) { border-color: hsl(var(--muted-foreground) / 0.4); }
      .pd-field-input:disabled { background: hsl(var(--muted)); color: hsl(var(--muted-foreground)); cursor: not-allowed; }
      .pd-field-label {
        font-size: 12px; font-weight: 500; letter-spacing: 0;
        text-transform: none; color: hsl(var(--muted-foreground)); margin-bottom: 6px; display: block;
      }
      .pd-pill {
        display: inline-flex; align-items: center; gap: 6px;
        padding: 3px 10px; border-radius: 999px; font-size: 12px;
        font-weight: 600; letter-spacing: 0; text-transform: none;
      }
      .pd-grid-row {
        display: grid; grid-template-columns: 1fr auto;
        padding: 8px 0; align-items: baseline; gap: 16px;
        border-bottom: 1px solid hsl(var(--border));
      }
      .pd-grid-row:last-child { border-bottom: none; }
      .pd-grid-row .pd-label { font-size: 13px; color: hsl(var(--foreground) / 0.8); }
      .pd-grid-row .pd-value { font-size: 13px; font-weight: 500; color: hsl(var(--foreground)); }
      .pd-step-num {
        display: inline-flex; align-items: center; justify-content: center;
        width: 28px; height: 28px; border-radius: 8px;
        background: hsl(var(--info-suave)); color: hsl(var(--primary)); font-size: 12px; font-weight: 700;
        font-family: "Inter", system-ui, -apple-system, "Segoe UI", sans-serif;
      }
      .pd-root button { font-family: inherit; cursor: pointer; }
      .pd-root button:disabled { cursor: not-allowed; opacity: 0.5; }
      .pd-item-card {
        padding: 12px 14px; border: 1px solid hsl(var(--border)); background: hsl(var(--card));
        border-radius: 8px; margin-bottom: 8px; cursor: pointer;
        transition: all 0.15s;
      }
      .pd-item-card:hover { border-color: hsl(var(--primary)); box-shadow: 0 1px 3px hsl(var(--primary) / 0.08); }
      .pd-item-card.active { border-color: hsl(var(--primary)); border-width: 2px; padding: 11px 13px; background: hsl(var(--info-suave)); }
      .pd-table-row { transition: background 0.15s; }
      .pd-table-row:hover { background: hsl(var(--muted) / 0.5); }
      .pd-table-row.active { background: hsl(var(--info-suave)); }
      .pd-table-row.active td:first-child { border-left: 3px solid hsl(var(--primary)); }
      @keyframes pd-fadeIn { from { opacity: 0; transform: translateY(4px); } to { opacity: 1; transform: translateY(0); } }
      /* Variante compacta de la ficha (sólo la maqueta la activa). */
      .pd-compacta .pd-field-input { padding: 5px 10px; }
      .pd-compacta .pd-field-label { margin-bottom: 3px; }
      .pd-compacta .pd-step-num { width: 24px; height: 24px; font-size: 12px; }
      .pd-par > section { min-width: 0; }
      @media (min-width: 1400px) {
        .pd-par { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 0 16px; align-items: start; }
        .pd-par > :only-child { grid-column: 1 / -1; }
      }
      .pd-fade-in { animation: pd-fadeIn 0.25s ease; }
      @media (prefers-reduced-motion: reduce) { .pd-fade-in { animation: none; } .pd-root *, .pd-root *::before, .pd-root *::after { transition-duration: 0.01ms !important; animation-duration: 0.01ms !important; } }
      .pd-add-btn-big {
        display: flex; align-items: center; justify-content: center; gap: 8px;
        padding: 14px; background: hsl(var(--card)); border: 2px dashed hsl(var(--muted-foreground) / 0.4);
        border-radius: 8px; width: 100%; font-size: 13px; font-weight: 600;
        color: hsl(var(--foreground) / 0.8); transition: all 0.15s; cursor: pointer;
        margin-top: 8px;
      }
      .pd-add-btn-big:hover { border-color: hsl(var(--primary)); border-style: solid; background: hsl(var(--info-suave)); color: hsl(var(--primary)); }
      .pd-add-btn-big:disabled { opacity: 0.55; cursor: default; }
      .pd-add-btn-big:disabled:hover { border-color: hsl(var(--muted-foreground) / 0.4); border-style: dashed; background: hsl(var(--card)); color: hsl(var(--foreground) / 0.8); }

      /* Carga masiva por plantilla: separado del alta de a uno para que no se
         confundan dos caminos que hacen cosas distintas. */
      .pd-carga-masiva { margin-top: 16px; padding-top: 12px; border-top: 1px solid hsl(var(--border)); }
      .pd-carga-masiva-cap {
        font-size: 12px; color: hsl(var(--muted-foreground)); font-weight: 600; margin-bottom: 2px;
      }
      .pd-carga-masiva-error {
        margin-top: 8px; padding: 8px 10px; border-radius: 6px;
        background: hsl(var(--bloqueo-suave)); border: 1px solid hsl(var(--bloqueo-borde)); color: hsl(var(--bloqueo)); font-size: 12px;
      }
      .pd-tab-btn {
        padding: 12px 18px; background: transparent; border: none;
        font-size: 13px; font-weight: 500; letter-spacing: 0;
        text-transform: none; color: hsl(var(--muted-foreground)); cursor: pointer;
        border-bottom: 2px solid transparent;
      }
      .pd-tab-btn.active { color: hsl(var(--primary)); border-bottom-color: hsl(var(--primary)); font-weight: 600; }
      .pd-tab-btn:hover { color: hsl(var(--foreground)); }
    `}</style>
  );
}

export const th: React.CSSProperties = {
  padding: '12px 14px',
  textAlign: 'left',
  fontSize: 12,
  fontWeight: 600,
  color: 'hsl(var(--foreground) / 0.8)',
};

export const td: React.CSSProperties = {
  padding: '12px 14px',
  fontSize: 13,
  color: 'hsl(var(--foreground))',
};

export const tdR: React.CSSProperties = {
  ...td,
  textAlign: 'right',
  fontFamily: '"IBM Plex Mono", monospace',
};

export const btnIcon: React.CSSProperties = {
  padding: '8px',
  background: 'hsl(var(--card))',
  border: '1px solid hsl(var(--border))',
  borderRadius: 6,
  color: 'hsl(var(--foreground) / 0.8)',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const btnSec: React.CSSProperties = {
  padding: '10px 16px',
  background: 'hsl(var(--card))',
  border: '1px solid hsl(var(--border))',
  borderRadius: 6,
  fontSize: 13,
  fontWeight: 500,
  color: 'hsl(var(--foreground) / 0.8)',
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
};

export const btnPri: React.CSSProperties = {
  padding: '10px 18px',
  background: 'hsl(var(--primary))',
  color: 'hsl(var(--primary-foreground))',
  border: 'none',
  borderRadius: 6,
  fontSize: 13,
  fontWeight: 600,
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  boxShadow: '0 1px 2px hsl(var(--primary) / 0.2)',
};
